import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type React from "react";
import { formatPokemonDisplayName } from "../utils/pokemonFormatter";

interface MappingsListProps {
  mappings: Map<string, string>;
  removeMapping: (text: string) => void;
}

function MappingsList({
  mappings,
  removeMapping,
}: MappingsListProps): React.JSX.Element {
  if (mappings.size === 0) {
    return (
      <div className="overflow-y-auto p-4 flex-1">
        <div className="empty-state">
          No mappings yet. Add some to get started!
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-y-auto p-4 flex-1">
      {Array.from(mappings.entries()).map(([text, pokemon]) => (
        <div key={text} className="mapping-item">
          <div className="mapping-text">"{text}"</div>
          <div className="mapping-pokemon">
            <img 
              src={
                pokemon.endsWith('-shiny')
                  ? `/pokemon/static/shiny/${pokemon}.png`
                  : `/pokemon/static/base/${pokemon}.png`
              } 
              alt={pokemon} 
              className="mapping-sprite" 
            />
            <span className="mapping-name">
              {formatPokemonDisplayName(pokemon) + (pokemon.endsWith('-shiny') ? ' (Shiny)' : '')}
            </span>
          </div>
          <button
            type="button"
            className="remove-button"
            onClick={() => removeMapping(text)}
            aria-label="Remove mapping"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      ))}
    </div>
  );
}

export default MappingsList;
